/* eslint-disable import/prefer-default-export */
export const CENTERLINK_STATUS = {
  NOT_READY: 'NOT_READY',
  READY: 'READY',
};

export const CENTERLINK_EVENTS = {
  COMPLETE: 'COMPLETE',
};
